import React from 'react'
import { SupportedBrands } from 'src/enums'

interface CobrandLogoProps {
  className?: string
  brandName: SupportedBrands.Bmo | SupportedBrands.Pnc | SupportedBrands.Jpm
}

const CobrandLogo: React.FC<CobrandLogoProps> = ({ brandName, className }) => {
  return (
    <img
      alt={brandName}
      className={className}
      src={`https://brand-assets.paywithextend.com/${brandName}/BrandLogo.svg`}
    />
  )
}

export default CobrandLogo
